let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hf48m"), load("jigcs"), load("4LmEY")]).then(() => parcelRequire('heHIK'));